import useTranslate from "hooks/useTranslate";
import { useRouterHistoryStore } from "stores/routerHistory";
import { useNavigate } from "react-router-dom";
import LoyaltyHelpFaq from "../../../organisms/LoyaltyHelpFaq";
import LoyaltyHelpTerms from "../../../organisms/LoyaltyHelpTerms";
import PageTitle from "../../../atoms/PageTitle";
import "./styles.sass";

const LoyaltyRules = () => {
  const navigate = useNavigate();
  const previousPage = useRouterHistoryStore((state) => state.previous);
  const t = useTranslate();

  return (
    <div className="loyaltyRules">
      <PageTitle
        title={t("loyalty.faq.title")}
        onBack={() => navigate(previousPage)}
        backText={t("popup.payment.error.back")}
      />
      <LoyaltyHelpFaq />
      <LoyaltyHelpTerms />
    </div>
  );
};

export default LoyaltyRules;
